<template>
  <v-form @submit.prevent="updateTeam" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">{{ mode }} new team</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>
            <v-layout row wrap> 
              <v-flex xs12 sm12 style="padding: 10px;">         
                <p v-if="error" style="color:red;">{{ errorMessage }}</p>         
                  <v-text-field label="Team Name" 
                    v-model="teamName" 
                    :rules="[rules.required]" 
                    :disabled="disabled"
                    maxlength="50"
                    hint="50 characters max"
                    @keyup="error=false"></v-text-field> 
                  <v-textarea v-model="description"  
                    label="Description" 
                    :rules="[rules.required]" 
                    rows="1" 
                    color="primary" 
                    @keyup="error=false"
                    maxlength="100"
                    hint="100 characters max" 
                    :disabled="disabled"></v-textarea>
                  
              </v-flex>
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="loading" style="color:white">{{ mode }}</v-btn>
            <v-btn @click="clearForm" :disabled="disabled" >clear</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
    import teamApi from '@/api/team'

  export default {
    name: 'login-dialog',
    data () {
      return {
        loading: false,
        disabled: false,
        error: false,       
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          } 
        },
        teamId: 0,
        teamName: '',
        description: '',
        error: false,
        errorMessage: '',
        mode: ''
      }
    },
    methods: {
      closeDialog() {
          this.$emit('update:dialogAdd', false)
          this.clearForm()
      },
      async updateTeam() {
        if (this.$refs.form.validate()) {
          try {
              this.loading = true
              this.disabled = true
              
              await teamApi.upsert(this.teamId, this.teamName, this.description, '')
              
              this.loading = false
              this.disabled = false
              
              this.closeDialog()
              this.$emit('send', '')
          } catch(error) {
            this.errorMessage = error
            this.error = true
          }
        }
      },
      setAddParams() {
        this.mode = 'Add'
        this.teamId = 0
        this.teamName = ''
        this.description = ''
      },
      setEditParams(data) {
        this.mode = 'Update'
        this.teamId = data.teamId
        this.teamName = data.name
        this.description = data.description
      },
      clearForm() {
        this.$refs.form.reset()
        this.error = false
      }
    },
    computed: {},
    created() {}
  }
</script>